const validateValue = (value, pattern) => {
  if (!value?.length) return false;
  console.log('pattern ', pattern);
  const isValueValid = pattern?.test(value);
  console.log('isValueValid ', isValueValid);
  return isValueValid;
};

export default validateValue;
